import React from 'react'
import {Helmet} from 'react-helmet'
import TermsOfUseComponent from './TermsOfUseComponent'

import MainLayout from 'src/components/MainLayout'
import styled from 'styled-components'

const Wrapper = styled.section`
  background-color: #f3f3f3;
`

const TermsOfUsePage: React.FC = () => {
    return (
        <MainLayout>
            <Helmet>
                <title>
                    Senspark | Terms of Use
                </title>
                <meta
                    property='og:title'
                    content='Senspark | Terms of Use'
                />
            </Helmet>
            <Wrapper>
                <TermsOfUseComponent />
            </Wrapper>
        </MainLayout>
    )
}

export default TermsOfUsePage
